export class LoadUserProjectIN {
    idProfile: number
    idProgetto: number
}
